module.exports = __webpack_public_path__ + "static/media/01_design_agd-neib-logo.96156027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/01_design_agd-neib-logo.jpg
// module id = 226
// module chunks = 0